import { NotifyHelper } from "../../../helpers/toast";
import { eDmNganhActionsObj } from "../../action-types/category/IDmNganhActions";
import { generateActions, generateActionForKey } from "../generateActions";

export const nganhActions = {
  ...generateActions(eDmNganhActionsObj, "NGANH"),
  ...generateActionForKey(eDmNganhActionsObj, "NGANH", "SAVE_SUCCESS", () => {
    NotifyHelper.Success("Thành công");
  }),
  ...generateActionForKey(eDmNganhActionsObj, "NGANH", "DELETE_SUCCESS", () => {
    NotifyHelper.Success("Thành công");
  }),
  ...generateActionForKey(eDmNganhActionsObj, "NGANH", "SAVE_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
  ...generateActionForKey(eDmNganhActionsObj, "NGANH", "DELETE_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
};
